import { sanitizeRich } from "@/lib/richtext";

export default function RichText({ html, text, className = "", testid, empty = null }) {
  if (html) {
    return <div data-testid={testid} className={`rich-content ${className}`} dangerouslySetInnerHTML={{ __html: sanitizeRich(html) }} />;
  }
  if (text && text.trim()) return <div data-testid={testid} className={`rich-content whitespace-pre-wrap ${className}`}>{text}</div>;
  return empty;
}
